import { Alert as AntdAlert, AlertProps } from 'antd';
import { FC } from 'react';

const Alert: FC<AlertProps> = (props) => {
  return <AntdAlert {...props} />;
};

export default Alert;
